import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-73bde4d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "modal"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "과거도착시각", -1 /* HOISTED */))
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "date-control" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-calendar",
  src: _imports_0,
  alt: "날짜 선택"
}, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "btns" }
const _hoisted_10 = { class: "bus-stops" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        appear: "",
        name: "slide-up"
      }, {
        default: _withCtx(() => [
          ($setup.shouldShowModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("header", _hoisted_3, [
                  _hoisted_4,
                  _createVNode($setup["InlineSvg"], {
                    class: "close-btn",
                    src: require('@/assets/icons/x-icon.svg'),
                    alt: "닫기",
                    onClick: $setup.closeModal
                  }, null, 8 /* PROPS */, ["src"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("section", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "date",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowCalendar(true)))
                    }, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString($setup.displayDate), 1 /* TEXT */),
                      _hoisted_8
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "btn left",
                        onClick: $setup.searchPreviousDate
                      }, [
                        _createVNode($setup["InlineSvg"], {
                          class: "img left",
                          src: require('@/assets/icons/light-caret-left.svg'),
                          alt: "이전 날짜"
                        }, null, 8 /* PROPS */, ["src"])
                      ]),
                      _createElementVNode("button", {
                        class: "btn right",
                        onClick: $setup.searchNextDate
                      }, [
                        _createVNode($setup["InlineSvg"], {
                          class: _normalizeClass(["img right", { disabled: !$setup.canSearchNextDate }]),
                          src: require('@/assets/icons/light-caret-right.svg'),
                          alt: "다음 날짜"
                        }, null, 8 /* PROPS */, ["class", "src"])
                      ])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.busStops, (busStop, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: busStop.id,
                        class: "layout-row"
                      }, [
                        _createVNode($setup["BusStopTimeRow"], {
                          busStop: busStop,
                          isLastRow: index === $props.busStops.length - 1,
                          arrivalTime: $setup.getArrivalTime(busStop.id)
                        }, null, 8 /* PROPS */, ["busStop", "isLastRow", "arrivalTime"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      ($setup.shouldShowCalendar)
        ? (_openBlock(), _createBlock($setup["Calendar"], {
            key: 0,
            class: "calendar",
            selectableToDate: $setup.yesterday,
            initialSelectedDate: $setup.targetDate,
            hideModalBackDrop: true,
            hideTodayButton: true,
            onOnSelectDate: $setup.updateTargetDateByCalendar
          }, null, 8 /* PROPS */, ["selectableToDate", "initialSelectedDate"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}